import { render, staticRenderFns } from "./bip-test.vue?vue&type=template&id=4e4f0092&scoped=true&"
import script from "./bip-test.vue?vue&type=script&lang=js&"
export * from "./bip-test.vue?vue&type=script&lang=js&"
import style0 from "./bip-test.vue?vue&type=style&index=0&lang=css&"
import style1 from "./bip-test.vue?vue&type=style&index=1&id=4e4f0092&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4f0092",
  null
  
)

export default component.exports